import { render, staticRenderFns } from "./CategoryDefault.vue?vue&type=template&id=066167f5&scoped=true&"
import script from "./CategoryDefault.vue?vue&type=script&lang=ts&"
export * from "./CategoryDefault.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDefault.vue?vue&type=style&index=0&id=066167f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066167f5",
  null
  
)

export default component.exports